import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProjectsList } from '@hooks/useProjectsList';
import { pickSite } from '@utils/pickSite';
import { Placeholder } from './Placeholder';

/**
 * A site-scoped section opened without a site (`/dashboard`, `/monitor`, …).
 * It opens the section for the user's site — the last one they worked in, else
 * their first — so nobody is stranded on a "pick a site" page. Only a user with
 * no site at all is told so; the copy never points at the portfolio, which
 * most roles can't open.
 */
export function SelectSite({ label }: { label: string }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { data: projects, isError } = useProjectsList();

  if (isError) {
    return <Placeholder kicker={t('selectSite.kicker')} title={label} body={t('selectSite.loadFailed')} />;
  }
  if (!projects) return null; // still loading — the route resolves in a moment

  const site = pickSite(projects, null);
  if (!site) {
    return <Placeholder kicker={t('selectSite.kicker')} title={label} body={t('selectSite.noSites')} />;
  }
  return <Navigate replace to={`${pathname.replace(/\/+$/, '')}/${encodeURIComponent(site.joinKey)}`} />;
}
